
export default function userHasPermission(permissionName: string): boolean {

    return true;
};